(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-get-participant-name.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-get-participant-name.js');
"use strict";

const {
  useSelector
} = ReactRedux;
const {
  createBetEventKey
} = svs.components.sportinfo.common.helpers;
const {
  selectBetEvent,
  selectParticipant
} = svs.components.sportinfo.matchInfoRedux.selectors;

const useGetParticipantName = (productId, drawNumber, betEventNumber) => {
  const betEvents = useSelector(state => selectBetEvent(state, createBetEventKey(productId, drawNumber, betEventNumber)));
  const homeParticipant = useSelector(state => selectParticipant(state, betEvents !== null && betEvents !== void 0 && betEvents.participants[0] ? betEvents === null || betEvents === void 0 ? void 0 : betEvents.participants[0] : undefined));
  const awayParticipant = useSelector(state => selectParticipant(state, betEvents !== null && betEvents !== void 0 && betEvents.participants[1] ? betEvents === null || betEvents === void 0 ? void 0 : betEvents.participants[1] : undefined));
  return [homeParticipant, awayParticipant];
};
setGlobal('svs.components.tipsen.hooks.useGetParticipantName', useGetParticipantName);

 })(window);